const styles = {
    // Primary color
    "color-primary": "#ee6900",
    "color-primary-default": "#ee6900",
    "color-primary-dark": "#bd5300",
    "color-primary-medium": "#F8C399",
    "color-primary-light": "#FDF0E6",
    // Secondary color
    "color-secondary": "#1c9690",
    "color-secondary-default": "#1c9690",
    "color-secondary-dark": "#146b67",
    "color-secondary-medium": "#a4d5d3",
    "color-secondary-light": "#e8f5f4",
    // Grey
    "color-gray-100": "#000b18",
    "color-gray-90": "#1a232f",
    "color-gray-85": "#26303b",
    "color-gray-80": "#333c46",
    "color-gray-60": "#666d74",
    "color-gray-30": "#b3b6ba",
    "color-gray-10": "#e6e7e8",
    "color-gray-5": "#f2f3f3",
    "color-gray-3": "#f7f8f8",
    //
    "background-signin": "url(/images/field-bg.jpeg)",
    "color-orange-climate": "var(--color-primary)",
}

export default styles
